import React from 'react'

const Privacy = () => {
  return (
    <div className='my-6'>
        {/* プライバシーポリシー */}
        <h2 className='text-2xl text-center mb-6'>プライバシーポリシー</h2>

        <div className='max-w-2xl mx-auto'>
            <p>大規模鬼ごっこ事務局（以下「当事務局」といいます）は、本Webアプリ「電鬼2」（以下「本アプリ」といいます）を運営するにあたり、ユーザーの個人情報の取り扱いについて以下のプライバシーポリシー（以下「本ポリシー」といいます）を定めます。</p>
            <p>本アプリを利用するユーザー（以下「ユーザー」といいます）は、本ポリシーに同意したものとみなします。</p>
            <p>当事務局は、本ポリシーを変更することがあります。変更後のポリシーは、本アプリに掲載した時点で効力を生じるものとします。</p>
            <p>なお、本ポリシーは、本アプリにおいてのみ適用され、本アプリ以外のウェブサイトやアプリケーションへのリンクは、本ポリシーの適用外となります。</p>

            <h3 className='text-xl mt-6 text-purple-800'>1. 収集する情報</h3>
            <p>本アプリでは、以下の情報を収集します。</p>
            <ul className='list-disc list-inside'>
                <li>ユーザーが本アプリを利用する際に入力する情報</li>
                <li>ユーザーが本アプリを利用する際に発生する情報</li>
            </ul>

            <h3 className='text-xl mt-6 text-purple-800'>2. 利用する情報</h3>
            <p>本アプリでは、以下の目的で情報を利用します。</p>
            <ul className='list-disc list-inside'>
                <li>本アプリの提供・運営のため</li>
                <li>本アプリに関するお知らせの送信のため</li>
                <li>本アプリに関する問い合わせに対応するため</li>
            </ul>

            <h3 className='text-xl mt-6 text-purple-800'>3. 情報の提供</h3>
            <p>本アプリでは、以下の場合を除き、情報を第三者に提供しません。</p>
            <ul className='list-disc list-inside'>
                <li>ユーザーの同意がある場合</li>
                <li>法令に基づく場合</li>
            </ul>

            <h3 className='text-xl mt-6 text-purple-800'>4. 情報の管理</h3>
            <p>本アプリでは、情報の管理に十分な注意を払います。</p>
            <p>また、情報の漏洩、滅失、き損等の危険に対して、合理的な安全対策を講じます。</p>

            <h3 className='text-xl mt-6 text-purple-800'>5. お問い合わせ</h3>
            <p>本ポリシーに関するお問い合わせは、以下のメールアドレスまでご連絡ください。</p>
            <p>メールアドレス：metrotagcomittee@gmail.com</p>

            <p className='text-end my-3'>2024年12月1日制定</p>
        </div>
    </div>
  )
}

export default Privacy